/*
 * @Author: your name
 * @Date: 2021-07-13 19:39:49
 * @LastEditTime: 2025-11-14 17:47:56
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\user\index.js
 */
import request from '../request';

const urlPre = '/user-center';
const baseUrl = request.getBaseUrl();
const server = {
  // 分页查询旗舰店列表
  queryStorePage(params) {
    return request.post(`${urlPre}/store/queryStorePage`, params);
  },
  // 保存旗舰店
  saveStore(params) {
    return request.post(`${urlPre}/store/saveStore`, params);
  },
  // 旗舰店提交审核
  submitStore(params) {
    return request.post(`${urlPre}/store/submitStore`, params);
  },
  // 品牌图片上传
  fileUploadForBrand: `${baseUrl}${urlPre}/oss/fileUploadForBrand`,
  // 供应商资质上传
  fileUploadForLicence: `${baseUrl}${urlPre}/oss/fileUploadForLicence`,
  // 获取供应商资质
  getSupplierLicence(params) {
    return request.fetch(`${urlPre}/oss/getSupplierLicence`, params);
  },
  // 企业运营中心查询消息
  queryMallNotice(params) {
    return request.post('/user-center/notice/queryMallNotice', params);
  },
  // 获取消息未读数量
  queryUnreadCount(params) {
    return request.fetch('/user-center/notice/queryUnreadCount', params);
  },
  // 查看消息
  readNotice(params) {
    return request.fetch('/user-center/notice/readNotice', params);
  },
  // 获取企业中心未读消息数量
  queryEaUnreadCount(params) {
    return request.fetch('/user-center/notice/queryEaUnreadCount', params);
  },
  // 查询用户申请状态
  queryUserApplyStatus(params) {
    return request.fetch(
      '/user-center/purchaseArea/queryUserApplyStatus',
      params
    );
  },
  // 查询拒绝原因
  queryRejectReason(params) {
    return request.fetch(
      '/cms/templateManagement/queryAuditReasonById',
      params
    );
  },
  // 非计划采购-插入或更新
  saveNotPlanPurchase(params) {
    return request.post(
      '/user-center/companyConfig/saveNotPlanPurchase',
      params
    );
  },
  // 查询非计划采购
  queryPlanPurchase(params) {
    return request.post('/user-center/companyConfig/queryPlanPurchase', params);
  },
  // 查询供应商信息列表
  getSupplierList(params) {
    return request.post(
      '/user-center/supplierManagement/querySupplierManagementInfoPage',
      params
    );
  },
  // 获取地区信息
  queryByParentId(params) {
    return request.post('/user-center/area/queryByParentId', params);
  },
  // 获取供应商评分
  getSupplierScore(params) {
    return request.fetch(
      '/user-center/supplierManagement/getSupplierScoreInfo',
      params
    );
  },
  // 保存供应商评分
  saveSupplierScore(params) {
    return request.post(
      '/user-center/supplierManagement/modifySupplierScoreInfo',
      params
    );
  },
  // 编辑保存供应商信息
  saveSupplierInfo(params) {
    return request.post(
      '/user-center/supplierManagement/modifySupplierManagementInfo',
      params
    );
  },
  // 获取运营方名称
  getCompanyInfo(params) {
    return request.fetch('/user-center/company/queryCompanyInfoById', params);
  }, //
  // 导出供应商列表
  downloadSupplierList(params) {
    return request.post(
      '/user-center/supplierManagement/exportSupplierInfo',
      params,
      {
        responseType: 'blob',
      }
    );
  },
  searchSupplierForStore(params) {
    return request.post('/user-center/search/searchSupplierForStore', params);
  },
  // 查询供应商产品目录
  querySupplierProductCatalogInfo(params) {
    return request.post(
      `/user-center/supplierManagement/querySupplierProductCatalogInfo?supplierId=${params}`
    );
  },
  // 查询供应商产简介及供应
  getSupplierOtherInfo(params) {
    return request.post(
      `/user-center/supplierManagement/getSupplierOtherInfo?supplierId=${params}`
    );
  },
  // 查询每日的PvUv
  queryBrandMallPvUv(params) {
    return request.fetch(
      '/data-center/supplierInfo/queryBrandMallPvUv',
      params
    );
  },
  // queryPuUvList: function(params) {
  //   return request.post("/data-center/dataCenter/queryPuUvList", params);
  // },
  // 查询供应商客户情况核心数据
  queryConsumerCore(params) {
    return request.fetch('/data-center/supplierInfo/queryConsumerCore', params);
  },
  // 查询供应商销售核心数据
  querySaleCore(params) {
    return request.fetch('/data-center/supplierInfo/querySaleCore', params);
  },
  // 查询供应商商品情况核心数据
  queryProductCore(params) {
    return request.fetch('/data-center/supplierInfo/queryProductCore', params);
  },
  // 查询供应商销售趋势分析数据
  querySaleMonth(params) {
    return request.fetch('/data-center/supplierInfo/querySaleMonth', params);
  },
  // 查询供应商商品销售规模地区排行数据
  querySaleProvince(params) {
    return request.fetch('/data-center/supplierInfo/querySaleProvince', params);
  },
  // 供应商资源-查询所有供应商
  queryCompanyGradeAllPage(params) {
    return request.post(
      '/user-center/companyGrade/queryCompanyGradeAllPage',
      params
    );
  },
  // 供应商资源-移除
  delete(params) {
    return request.post('/user-center/supplierManagement/delete', params);
  },
  // 供应商资源-批量添加
  batchInsert(params) {
    return request.post('/user-center/supplierManagement/batchInsert', params);
  },
  // 供应商资源-下载批量新增供应商模版
  excelDown(params) {
    return request.fetch('/user-center/supplierManagement/excelDown', params, {
      responseType: 'blob',
    });
  },
  // 供应商资源-供应商资源导入
  supplierImport(params) {
    return request.post('/user-center/supplierManagement/import', params);
  },
  // 查询支付方式配置--企业运营后台前端调用
  queryOwnPaymentConfig(params) {
    return request.fetch(
      '/user-center/companyConfig/queryOwnPaymentConfig',
      params
    );
  },
  // 新增支付方式配置
  addPaymentConfig(params) {
    return request.post('/user-center/companyConfig/addPaymentConfig', params);
  },
  // 判断是否开通在线支付   判断供应商
  batchJudgeOnlinePayment(params) {
    return request.post('/user-center/company/batchJudgeOnlinePayment', params);
  },
  // 获取供应商资源详情
  queryCompanyDetail(params) {
    return request.post('/user-center/company/queryCompanyDetail', params);
  },
  // 订单取消配置项-插入或更新
  saveOrderCancelConfig(params) {
    return request.post(
      '/user-center/companyConfig/saveOrderCancelConfig',
      params
    );
  },
  // 订单取消配置项  查询
  queryOrderCancelConfig(params) {
    return request.post(
      '/user-center/companyConfig/queryOrderCancelConfig',
      params
    );
  },
  //   接口1.订单数据权限配置保存  user-center/companyConfig/saveOrderDataRightConfig
  // post接口 入参如下
  // {
  //     "data": "163"
  // }
  // 161不限制,162,按组织机构设置,163,按下单人限制

  // 订单数据权限配置保存
  saveOrderDataRightConfig(params) {
    return request.post('/user-center/companyConfig/saveOrderDataRightConfig', params);
  },
  // 接口2.订单数据权限配置查询 user-center/companyConfig/queryOrderDataRightConfig
  // post接口，不需要传参

  // 查询订单数据权限配置
  queryOrderDataRightConfig(params) {
    return request.post('/user-center/companyConfig/queryOrderDataRightConfig', params);
  },
  // 卡片相关接口
  // 卡片列表
  cardList(params) {
    return request.post('/user-center/staging/card/list', params);
  },
  // 获取用户卡片列表  查询
  userCardList(params) {
    return request.post('/user-center/staging/card/user/list', params, {
      preventRepeat: false,
    });
  },
  // 订单取消配置项  查询
  saveCardList(params) {
    return request.post('/user-center/staging/card/user/save', params);
  },
  // 获取新手引导标识
  noviceGuidance(params) {
    return request.post('/user-center/noviceGuidance/get/flag', params);
  },
  // 取消新手引导
  noviceGuidanceClose(params) {
    return request.post('/user-center/noviceGuidance/staging/close', params);
  },
  // 新增发票
  saveAndUpdateInvoiceManage(params) {
    return request.post(
      '/user-center/invoice/saveAndUpdateInvoiceManage',
      params
    );
  },

  // 合规承诺书
  checkAgreementConformance(params) {
    return request.post('/user-center/home/checkAgreementConformance', params);
  },

  // 是否易派客2.0的管理员，如果是采购商管理员、供应商管理员的任意一个
  memberIsAdmin(params) {
    return request.post('/ubm/member/isAdmin', params);
  },
  // 备案登记配置
  queryInquiryRate(params) {
    return request.post('/user-center/resourceFiling/queryInquiryRate', params);
  },
  // 查询当前公司的整体情况
  mainInfo(params) {
    return request.post('/user-center/yzcCompany/mainInfo', params);
  },
  // 是否是  易专采的 企业管理员、采购商管理员
  isPurchaserAdmin(params) {
    return request.post('/ubm/member/isPurchaserAdmin', params);
  },
  // 查询易专采的组织机构配置;   查询是否要勾选《服务协议》和《平台规则》
  memberActionQuery(params) {
    return request.post('/user-center/memberAction/query', params);
  },
  // 更改易专采的组织机构配置
  memberActionSave(params) {
    return request.post('/user-center/memberAction/save', params);
  },
  // 查询用户全部发票
  queryInvoiceList(params) {
    return request.post('/user-center/invoice/queryList', params);
  },
  // 查询用户全部发票邮寄地址
  invoiceAddressList(params) {
    return request.post('/user-center/address/invoiceAddressList', params);
  },
  // 查询一级分类、二级分类树 post方法
  queryTree(params) {
    return request.post('/user-center/industryClass/queryTree', params);
  },
  // 查询供应商名称
  querySupplierByName(params) {
    return request.fetch(
      '/user-center/epecCompany/querySupplierByCompanyNameNoStatus',
      params
    );
  },
  // 企业法人文件上传
  fileUploadForCompanyCreditEvaluation: `${baseUrl}${urlPre}/oss/fileUploadForCompanyCreditEvaluation `,
  // 新增企业信用评价
  addCompanyCreditEvaluation(params) {
    return request.post('/user-center/companyCreditEvaluation/add', params);
  },
  // 查询企业审计报告
  queryAuditReportByYear(params) {
    return request.post(
      '/user-center/companyCreditEvaluation/queryAuditReportByYear',
      params
    );
  },
  // 查询评价机构录入企业信用评价数据
  queryCompanyCreditEvaluationPage(params) {
    return request.post(
      '/user-center/companyCreditEvaluation/queryPage',
      params
    );
  },
  // 查询评价机构录入企业信用评价数据
  queryCompanyCreditEvaluationDetail(params) {
    return request.fetch(
      '/user-center/companyCreditEvaluation/queryDetail',
      params
    );
  },
  // 编辑企业信用评价数据
  modifyCompanyCreditEvaluation(params) {
    return request.post('/user-center/companyCreditEvaluation/modify', params);
  },

  // 批量删除企业信用评价数据
  deletedCompanyCreditEvaluation(params) {
    return request.post(
      '/user-center/companyCreditEvaluation/batchDelete',
      params
    );
  },
  // 询比价服务获取协议获取地址
  queryCompanyLegalRepresentativeAndRegCity(params) {
    return request.post(
      '/user-center/company/queryCompanyLegalRepresentativeAndRegCity',
      params
    );
  },
  // 确认审计报告
  confirmAuditReport(params) {
    return request.fetch(
      '/user-center/companyCreditEvaluation/confirmAuditReport',
      params
    );
  },

  // 跳转第三方
  createEncryptionParam(params) {
    return request.fetch('/auth/thirdPartAuth/createEncryptionParam', params);
  },
  // 是否开通专采
  isOpenPurchaseArea(params) {
    return request.fetch(
      '/user-center/purchaseArea/isOpenPurchaseArea',
      params
    );
  },
  // 是否隐藏询比价协议
  isHiddenInquiryAndComparisonAgreement(params) {
    return request.post(
      '/user-center/companyConfig/isHiddenInquiryAndComparisonAgreement',
      params
    );
  },
  // 根据公司id确认是否隐藏协议
  isHiddenInquiryAndComparisonAgreementByCompanyId(params) {
    return request.fetch(
      'user-center/companyConfig/isHiddenInquiryAndComparisonAgreementByCompanyId',
      params
    );
  },
  // 批量获取企业的电子发票开通状态及电子发票开关
  listInfoAndSwitch(params) {
    return request.post(
      'user-center/companyElectronicInvoiceInfo/listInfoAndSwitch',
      params
    );
  },
  // 更新报告
  updateAuditReport(params) {
    return request.fetch(
      '/user-center/companyCreditEvaluation/reGetAuditReport',
      params
    );
  },
  // 查询采购产品范围
  queryPurchaseProductRangeSet(params) {
    return request.post(
      '/user-center/companyConfig/queryBuyProductScope',
      params,
      {
        preventRepeat: false,
      }
    );
  },
  // 维护销售联系人查询采购商
  queryPurchaserBySalesContact(params) {
    return request.post('/user-center/companyContacts/pageCustomer', params);
  },
  // 安全责任
  // memberActionQuery(params) {
  //   return request.post('user-center/memberAction/query', params);
  // },
  // memberActionSave(params) {
  //   return request.post('user-center/memberAction/save', params);
  // },
  // 查询供应商库
  querySupplierList(params) {
    return request.post('/user-center/subSupplier/queryPage', params);
  },
  // 批量添加供应商
  batchAddSupplier(params) {
    return request.post(
      '/user-center/subSupplierApply/batchAddAndPass',
      params
    );
  },
  // 供应商维护列表
  subSupplierList(params) {
    return request.post('/user-center/subSupplierApply/queryPage', params);
  },
  // 删除供应商删除  user-center/subSupplierApply/delete?applyId=1  get请求
  deleteSubSupplier(params) {
    return request.fetch('/user-center/subSupplierApply/delete', params);
  },
  // 手动添加供应商user-center/subSupplierApply/add
  addSubSupplier(params) {
    return request.post('/user-center/subSupplierApply/add', params);
  },
  // 分供应商模糊查询--返回10条
  querySubSupplierByName(params) {
    return request.post('/user-center/company/querySupplierByName', params);
  },
  // 文件上传  user-center/oss/fileUploadForSubSupplier
  fileUploadForSubSupplier: `${baseUrl}${urlPre}/oss/fileUploadForSubSupplier`,
  // 批量导入供应商
  batchImportSubSupplier: `${baseUrl}${urlPre}/subSupplierApply/import`,
  // 下载模版
  excelDownSubSupplier(params) {
    return request.fetch('/user-center/subSupplierApply/excelDown ', params, {
      responseType: 'blob',
    });
  },
  // 批量上传供应商上传附件
  batchAddSubSupplier(params) {
    return request.post('/user-center/subSupplierApply/batchAdd', params);
  },
  // 导出  user-center/subSupplierApply/export
  exportSubSupplier(params) {
    return request.post('/user-center/subSupplierApply/export', params, {
      responseType: 'blob',
    });
  },

  // 是否分供应商
  isSubSupplier(params) {
    return request.post('/user-center/subSupplierApply/isSubSupplier', params);
  },
  // 品类  查询当前用户所在企业的供应商白名单
  querySupplierWhiteList(params) {
    return request.post(
      '/user-center/companyType/querySupplierWhiteList',
      params,
      { preventRepeat: false }
    );
  },
};

export default server;
